export default {
  "couponLib.serialCode": "シリアルコード",
  "couponLib.distributionConditions": "配布条件",
  "couponLib.repeatedUsed": "併用可能",
  "couponLib.canNotRepeatedUsed": "併用不可",
  "couponLib.plsEnterRepeatedUsed": "併用可能/不可を設定してください",
  "couponLib.useCount": "發行枚数",
  "couponLib.usedNumber": "使用済み",
  "couponLib.useNumber": "利用可能回数",
  "couponLib.expiredDate": "有効期間",
  "couponLib.serialCodeManagement": "シリアルコード管理",
  "couponLib.voucherNumber": "招待券番号",
  "couponLib.couponNumber": "劇場優待券番号",
  "couponLib.issueDate": "発行日時",
  "couponLib.activationDate": "アクティベート日時",
  "couponLib.tradingCode": "関連取引番号",
  "couponLib.exchangeDate": "引換日時",
  "couponLib.issueAll": "すべて発行",
  "couponLib.issueTypeAll": "一括発行",
  "couponLib.issueTypePOS": "POS発行",
  "couponLib.collectiveEffect": "一括有效",
  "couponLib.effective": "有効済み",
  "couponLib.ineffective": "無効済み",
  "couponLib.issued": "発行済み",
  "couponLib.used": "利用済み",
  "couponLib.validTime": "有効時間",
  "couponLib.discountAmount": "割引額",
  "couponLib.preferentialPrice": "優待価格",
  "couponLib.plsEnterDiscountAmount": "割引額（¥）を入力してください",
  "couponLib.plsEnterPreferentialPrice": "優待価格（¥）を入力してください",
  "couponLib.theaterCouponsVouchers": "劇場優待券（クーポン・引換券）",
  "couponLib.performanceIncome": "興行収入",
  "couponLib.accReceivableCalc": "売掛金計算",
  "couponLib.validDate": "有效期限",
  "couponLib.plsSelectValidDate": "有效期限を選択してください",
  "couponLib.plsEnterValidDays": "有效期限を入力してください",
  "couponLib.plsSelectValidDateType": "有效期限種類を選択してください",
  "couponLib.ascendingOrderOfNum": "（数字が小さい順）",
  "couponLib.couponVoucherDepartment_POS": "劇場優待券（クーポン・引換券）部門（POS）",
  "couponLib.termsOfUse": "利用条件",
  "couponLib.clientSetting": "取引先設定",
  "couponLib.clientAR": "取引先（売掛金）",
  "couponLib.clientCommission": "取引先（手数料）",
  "couponLib.expirationType": "有效期限種類",
  "couponLib.plsSelectExpirationType": "有效期限種類を選択してください",
  "couponLib.ticketTypeDiscount": "割引種類",
  "couponLib.useType.ticket": "チケット",
  "couponLib.useType.item": "物贩",
  "couponLib.useType.seat": "座位",
  "couponLib.useType.version": "版本",
  "couponLib.available_day": "利用可能（日）",
  "couponLib.notAvailable_day": "利用不可（日）",
  "couponLib.deadline": "指定した日まで",
  "couponLib.period": "発行してから一定期間",
  "couponLib.none": "無制限",
  "couponLib.ticketType": "券種",
  "couponLib.plsSelectTicketType": "券種を選択してください",
  "couponLib.amountOfBoxOfficeRevenue": "興行収入計上金額",
  "couponLib.plsEnteramountOfBoxOfficeRevenue": "興行収入計上金額を入力してください",
  "couponLib.boxOfficeAmountTip": "※未設定の場合は、優待券適用後の金額で計上されます。",
  "couponLib.ticketPrintAmount": "チケット印字金額",
  "couponLib.ticketPrintAmountTip": "※未設定の場合は、優待券適用後の金額で印字されます。",
  "couponLib.numOfIssues": "発行枚数",
  "couponLib.displayOrder_asce": "表示順（昇順）",
  "couponLib.theaterAdvTicket": "劇場前売券",
  "couponLib.invitationTicket": "招待券",
  "couponLib.unlimited": "無制限",
  "couponLib.wholePeriod": "全期間",
  "couponLib.plsEnterUseNumber": "利用可能回数を入力してください",
  "couponLib.confirmOverwriteSettings": "選択した劇場の設定が上書きされますが、よろしいですか",
  "couponLib.plsSelectApplicableTheater": "該当する劇場を選択してください",
  "couponLib.plsEnterExpiredDate": "有効期限を入力してください",
  "couponLib.plsSelectSeatType": "座席を選択してください",
  "couponLib.seatType.special": "特別席",
  "couponLib.seatType.general": "一般席",
  "couponLib.seatType.wheelchair": "車椅子席",
  "couponLib.seatType.vip": "VIP席",
  "couponLib.seatType.lovers": "ペアシート",
  "couponLib.plsSelectVersion1": "バージョンを選択してください",
  "couponLib.applicableItem": "適用アイテム",
  "couponLib.applicableSeat": "適用座席",
  "couponLib.applicableVersion": "適用バージョン",
  "couponLib.applicationScope": "適用範囲",
  "couponLib.SeatTypeDiscount": "座席割引",
};